import { useEffect, useState } from "react"
import * as Sentry from "@sentry/react"
import { config } from "Utils/config"

export const useVersionCheck = (intervalMs = 60_000) => {
  const [outdated, setOutdated] = useState(false)

  useEffect(() => {
    let t: any
    const check = async () => {
      try {
        const res = await fetch(`/meta.json?ts=${Date.now()}`, { cache: "no-store" })
        if (!res.ok) throw new Error(`meta.json ${res.status}`)
        const { release } = await res.json()
        if (release && release !== config.RELEASE) {
          setOutdated(true)
          Sentry.addBreadcrumb({
            category: "version",
            message: `mismatch ${config.RELEASE} -> ${release}`,
            level: "info",
          })
        }
      } catch {
        // silencieux
      }
      t = setTimeout(check, intervalMs)
    }
    check()
    return () => clearTimeout(t)
  }, [intervalMs])

  return outdated
}